<template>
	<div class="c-detail-item flex flex-grow" :style="{'width': full ? '100%' : '50%'}">
		<label class="c-detail-item-label flex-end-main">{{label}}</label>
		<div class="c-detail-item-content flex-grow">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			label: String,
			
			full: Boolean
		}
	};
</script>